import React, { useEffect } from 'react';
import Navigation from './Navigation';
import SustainabilitySection from './SustainabilitySection';
import Footer from './Footer';
import PageSEO from './PageSEO';

const SustainabilityPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <PageSEO path="/sustainability" />
      <Navigation />
      <main style={{ paddingTop: '60px' }}>
        <SustainabilitySection />
      </main>
      <Footer />
    </>
  );
};

export default SustainabilityPage;
